import React from "react";
import DataTable from "react-data-table-component";

const CustomPaginationTable = (props) => {
  const {
    data,
    totalRows,
    loading,
    perPage,
    currentPage,
    onPageChange,
    columns,
    onPerRowsChange,
    isHiddenPag,
    onSort
  } = props;

  const customStyles = {
    headRow: {
      style: {
        borderBottom: '1px dashed #E2E2E2',
        fontSize: '12px',
        fontWeight: '700',
      }
    },
    cells: {
      style: {
        fontSize: '12px',
        fontWeight: '400',
        padding: '20px',
        backgroundColor: 'white'
      },
    },
    pagination: {
      style: {
        fontSize: '16px',
      },
    },
  };

  return (
    <DataTable
      columns={columns}
      data={data}
      progressPending={loading}
      pagination={!isHiddenPag}
      striped
      paginationPerPage={perPage}
      paginationServer
      paginationTotalRows={totalRows}
      paginationRowsPerPageOptions={[10, 20, 50]}
      paginationDefaultPage={currentPage}
      onChangeRowsPerPage={onPerRowsChange}
      onChangePage={onPageChange}
      customStyles={customStyles}
    />
  );
};

export default CustomPaginationTable;